import {
    URLAPI,
    NOVELTY_VEHICLE_MAINTENANCE_PATH,
    NOVELTY_VEHICLE_MAINTENANCE_CREATE_PATH,
    NOVELTY_VEHICLE_MAINTENANCE_UPDATE_PATH,
    NOVELTY_VEHICLE_MAINTENANCE_REPORT_PATH,
    NOVELTY_VEHICLE_MAINTENANCE_ITEM_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_novelty_vehicle_maintenance: {
        data: [],

        status: 0,
        message: {},
    },
    _create_novelty_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _update_novelty_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_NOVELTY_VEHICLE_MAINTENANCE = "GET_ALL_NOVELTY_VEHICLE_MAINTENANCE";
export const CREATE_NOVELTY_VEHICLE_MAINTENANCE = "CREATE_NOVELTY_VEHICLE_MAINTENANCE";
export const UPDATE_NOVELTY_VEHICLE_MAINTENANCE = "UPDATE_NOVELTY_VEHICLE_MAINTENANCE";
export const GET_REPORT = "GET_REPORT";

export const novelty_vehicle_maintenance_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_NOVELTY_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _get_all_novelty_vehicle_maintenance: action.payload,
            };
        case CREATE_NOVELTY_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _create_novelty_vehicle_maintenance: action.payload,
            };
        case UPDATE_NOVELTY_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _update_novelty_vehicle_maintenance: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllNoveltyVehicleMaintenance = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${NOVELTY_VEHICLE_MAINTENANCE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_NOVELTY_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_NOVELTY_VEHICLE_MAINTENANCE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_NOVELTY_VEHICLE_MAINTENANCE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemNoveltyVehicleMaintenance = async (token, id) => {
    return await axios.get(`${URLAPI}${NOVELTY_VEHICLE_MAINTENANCE_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

//create novelty_vehicle_maintenance
export const createNoveltyVehicleMaintenance = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${NOVELTY_VEHICLE_MAINTENANCE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_NOVELTY_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_NOVELTY_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_NOVELTY_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateNoveltyVehicleMaintenance = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${NOVELTY_VEHICLE_MAINTENANCE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_NOVELTY_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_NOVELTY_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_NOVELTY_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + NOVELTY_VEHICLE_MAINTENANCE_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_novelty_vehicle_maintenance = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
